import { useEffect, useState, useCallback } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { ContentTitleBar } from "../../components/ContentTitleBar";
import { useNavigate, useParams } from "react-router-dom";
import { checkStatusWhitelist } from "../../store/navigationUtil";
import { loadClip } from "./utils/dataLoader";
import { useClip } from "../../store/clip/hooks";
import { UPLOAD_ERROR } from "../../store/statuses";

export const UploadErrorPage = () => {
  const navigate = useNavigate();
  const { deleteClip } = useClip();
  const { caseId, clipId } = useParams();
  const [clip, setClip] = useState(null);

  const load = useCallback(async () => {
    const currClip = await loadClip(caseId, clipId);
    if (!checkStatusWhitelist(currClip, [UPLOAD_ERROR])) {
      navigate(`/app/cases/${caseId}/clips`);
    }
    setClip(currClip);
  }, [caseId, clipId, navigate]);

  const handleDeleteClip = () => {
    //dispatch delete clip function and then navigate back to clips
    deleteClip(clip);
    navigate(`/app/cases/${caseId}/clips`);
  };

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Stack component="main" height={1}>
      <Stack flex={1} gap={2} p={2}>
        <Paper elevation={4} sx={{ p: 2 }}>
          <Box display="flex" flexWrap="wrap" columnGap={8} rowGap={2}>
            <Box display="flex" flexDirection="column">
              <Typography variant="caption">STATUS</Typography>
              <Chip
                color="error"
                label="Upload Error"
                sx={{ alignSelf: "flex-start" }}
              />
            </Box>
            <Box display="flex" flexDirection="column">
              <Typography variant="caption">PROCESSED AUDIO FILES</Typography>
              <Typography variant="h5" sx={{ marginLeft: 7 }}>
                ---
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column">
              <Typography variant="caption">PROGRESS</Typography>
              <Typography variant="h5">0%</Typography>
            </Box>
          </Box>
        </Paper>
        <Alert severity="error" sx={{ boxShadow: 3 }} variant="outlined">
          The upload is in an error state. Please return to clips or delete
          clips.
        </Alert>
        <Box display="flex" alignItems="center" gap={2}>
          <Button
            variant="contained"
            onClick={async () => {
              navigate(`/app/cases/${caseId}/clips`);
            }}
          >
            RETURN TO CLIPS
          </Button>
          <Button variant="contained" color="error" onClick={handleDeleteClip}>
            DELETE CLIPS
          </Button>
        </Box>
      </Stack>
      <ContentTitleBar name={clip?.description} label="Clip Error" />
    </Stack>
  );
};
